(function () {
    let favCache = {};

    window.removeFavorites = function () {
        eraseCookie('favProposalIds');
        eraseCookie('favChallengeIds');
        eraseCookie('favDonorIds');
        eraseCookie('favTeacherIds');
        eraseCookie('favSchoolIds');
        eraseCookie('favSearchURLs');
        eraseCookie('myGPs');
        eraseCookie('hasViewableGPs');
        eraseCookie('favCookiesSet');

        favCache = {};

        dcLocalStorage.setCrossDomainValue('favProposalIds', '[]', null);
        dcLocalStorage.setCrossDomainValue('favChallengeIds', '[]', null);
        dcLocalStorage.setCrossDomainValue('favDonorIds', '[]', null);
        dcLocalStorage.setCrossDomainValue('favTeacherIds', '[]', null);
        dcLocalStorage.setCrossDomainValue('favSchoolIds', '[]', null);
        dcLocalStorage.setCrossDomainValue('favSearchURLs', '[]', null);
        dcLocalStorage.setCrossDomainValue('myGPs', '[]', null);

        $(document).trigger('removeFavorites');
    };

    // TODO: rename this function to show that we're updating favorites based on json
    window.updateFavoritesCookie = function () {
        removeFavorites();
        const e = document.createElement('script');
        e.type = 'text/javascript';
        e.src = secureBaseURL + 'common/json-favorites.html?callback=addFavoritesToLocalStorage&timestamp=' + (new Date()).getTime();
        document.getElementsByTagName('head')[0].appendChild(e);
    };

    function tryToConvertFavDataToLocalStorage(favCookieName, data) {
        const favIds = data.favIds[favCookieName];
        if (favIds) {
            favCache[favCookieName] = favIds;
            dcLocalStorage.setCrossDomainValue(favCookieName, JSON.stringify(favIds), null);
        }
    }

    window.tryToConvertMyGPIdsToLocalStorage = function (data) {
        const myGPs = data.favIds.myGPs;
        if (myGPs) {
            favCache.myGPs = myGPs;
            dcLocalStorage.setCrossDomainValue('myGPs', JSON.stringify(myGPs), null);
        }
    };

    // Only used in rollup modules
    window.addFavoritesToLocalStorage = function (obj) {
        if (!obj || !obj.data || !obj.data.favIds) return;

        tryToConvertFavDataToLocalStorage('favProposalIds', obj.data);
        tryToConvertFavDataToLocalStorage('favChallengeIds', obj.data);
        tryToConvertFavDataToLocalStorage('favDonorIds', obj.data);
        tryToConvertFavDataToLocalStorage('favTeacherIds', obj.data);
        tryToConvertFavDataToLocalStorage('favSchoolIds', obj.data);
        tryToConvertFavDataToLocalStorage('favSearchURLs', obj.data);
        tryToConvertMyGPIdsToLocalStorage(obj.data);

        // add favCookiesSet cookie -- indicates to header if the user has any favorites
        createCookie('favCookiesSet', (obj.data.favIds.favCookiesSet) ? 'true' : 'false', 365);

        // add hasViewableGPs cookie -- indicates to header if user has any giving pages (active or archived)
        createCookie('hasViewableGPs', (obj.data.favIds.hasViewableGPs) ? 'true' : 'false', 365);

        $(document).trigger('updateFavoritesCookie');
    };

    // example of usage
    // $.when(getFavList("myGPs")).then(function(favList) { alert(favList); });
    window.getFavList = function (favType) {
        const favList = favCache[favType];
        if (favList != null) {
            return favList;
        } else {
            return $.Deferred(function (defer) {
                dcLocalStorage.requestCrossDomainValue(favType, function (key, value) {
                    if (value != null && value != '') favCache[favType] = value;
                    else favCache[favType] = [];
                    defer.resolve(favCache[favType]);
                });
            });
        }
    };

    window.isSearchAFavorite = function (searchURL, searchVOHashCode, favSearchURLs, favSchoolIds) {
        let isFavorite = favSearchURLs && favSearchURLs.indexOf(searchVOHashCode) > -1;

        if (!isFavorite && favSchoolIds) {
            const schoolId = parseInt(getURLParam(searchURL, 'school'), 10);
            isFavorite = favSchoolIds.includes(schoolId);
        }

        return !!isFavorite;
    };
})();
